import GeneralUtils from './generalUtils';

export type AzureUserType = 'Admin' | 'Support' | 'User';

// -PROD- data
// aad-app-admpnl-vmesupport-prod; Group-ID: 496adf28-cb09-4ad9-8f2b-35e4a3428281 // !! 2026-01 in practice this group is NOT used anymore, support users are in `vme-admin`,but we keep it for the case if we need to separate them in the future OR DELETE it later
// aad-app-admpnl-vmeadmin-prod; Group-ID: 80eee2f3-d108-4cf3-8505-d93d9a698fef
// aad-app-admpnl-gsadmin-prod; Group-ID: 3193d9d0-36c4-4e31-ae6e-c011405301e9
// -STAGING- data
// NO support group in STAGING
// aad-app-admpnl-vmeadmin-staging; Group-ID: c4449395-7d05-46bc-9c35-c281e951f0aa
// aad-app-admpnl-gsadmin-staging; Group-ID: 13ce3d47-ed60-40c3-993f-3d87df50fc22
//
// -localDev- data
// `vme-admin` ID: `b9d13f54-7fe5-452c-8b1d-24db1e8c1875`

// Moved configuration out of the class to prevent re-allocation
const ENV_CONFIG = {
  LOCAL: {
    // globalAdmin: { name: 'vme-admin22', groupId: 'c9d13f54-7fe5-452c-8b1d-24db1e8c1875' },
    // support: { name: 'vme-admin22', groupId: 'c9d13f54-7fe5-452c-8b1d-24db1e8c1875' },
    globalAdmin: { name: 'vme-admin', groupId: 'b9d13f54-7fe5-452c-8b1d-24db1e8c1875' },
    support: { name: 'vme-admin', groupId: 'b9d13f54-7fe5-452c-8b1d-24db1e8c1875' },
    singleCompanyAdmin: { name: 'vme-admin', groupId: 'b9d13f54-7fe5-452c-8b1d-24db1e8c1875' },
    portalUser: { name: 'aad-app-vme-portal', groupId: 'ab778d74-cc6b-4c20-a9fe-6845f776284d' },
  },
  STAGING: {
    globalAdmin: { name: 'aad-app-admpnl-vmeadmin-staging', groupId: 'c4449395-7d05-46bc-9c35-c281e951f0aa' },
    support: { name: 'no-group', groupId: '' }, // No support group in Staging
    singleCompanyAdmin: { name: 'aad-app-admpnl-gsadmin-staging', groupId: '13ce3d47-ed60-40c3-993f-3d87df50fc22' },
    portalUser: { name: 'aad-app-vme-portal', groupId: 'ab778d74-cc6b-4c20-a9fe-6845f776284d' },
  },
  PROD: {
    globalAdmin: { name: 'aad-app-admpnl-vmeadmin-prod', groupId: '80eee2f3-d108-4cf3-8505-d93d9a698fef' },
    support: { name: 'aad-app-admpnl-vmesupport-prod', groupId: '496adf28-cb09-4ad9-8f2b-35e4a3428281' },
    singleCompanyAdmin: { name: 'aad-app-admpnl-gsadmin-prod', groupId: '3193d9d0-36c4-4e31-ae6e-c011405301e9' },
    portalUser: { name: 'aad-app-vme-portal', groupId: 'ab778d74-cc6b-4c20-a9fe-6845f776284d' },
  },
} as const;

// Type definitions
type EnvType = keyof typeof ENV_CONFIG;
type GroupType = 'globalAdmin' | 'support' | 'singleCompanyAdmin' | 'portalUser';

export default class AuthUtils {
  public static getTenantId(): string {
    let tenantId =
      GeneralUtils.isDevEnvironment() || this.isUrlInclude('dev4you')
        ? GeneralUtils.isLocalDevEnv()
          ? '9d3a2809-e0a2-4cfd-b2ce-bd540b6da009'
          : '2775340b-b251-401c-bcac-e05e5f499a3b'
        : 'f606a097-2d4d-4038-97f3-4287834b31bf'; // Azure tenantId is the same both for multiple `clienId`
    return tenantId;
  }

  public static getClientId(): string {
    let clientId =
      GeneralUtils.isDevEnvironment() || this.isUrlInclude('dev4you')
        ? GeneralUtils.isLocalDevEnv()
          ? '591cf799-7461-4f0b-bc5f-5044e5684126'
          : '5ee51967-6ecb-4bea-b004-dbd1b766afe5'
        : this.isUrlInclude('staging')
        ? '8ed01024-52b4-4843-a02c-0a5f6f72945b'
        : this.isUrlInclude('admpnl.meinvme.de') || this.isUrlInclude('zrsplitter.meinvme.de')
        ? '7c241376-7aa4-41e6-8308-32957bfb5f73'
        : 'NO ID';
    //        `10210597-b03a-461a-8082-f0853a78b5b2` for Staging env (staging.zr-gs.meinvme.de until 2024-09)

    // URLs:
    // Staging: https://staging.admpnl.meinvme.de/
    // Prod: https://admpnl.meinvme.de/
    return clientId;
  }

  // Default `false` mean user will have `Admin` role locally
   public static isForceOnlyGsUser = false;
 // public static isForceOnlyGsUser = true; // by default user is Admin+Support change to `true` to be in ONLY 1 role `GsUser`

  private static getEnvType(): EnvType {
    if (GeneralUtils.isLocalDevEnv()) return 'LOCAL';

    const host = window.location.hostname.toLowerCase();
    // if (host.includes('staging.admpnl.meinvme.de')) return 'STAGING';
    // if (host.includes('admpnl.meinvme.de')) return 'PROD';
    if (host === 'staging.admpnl.meinvme.de') return 'STAGING';
    if (host === 'admpnl.meinvme.de') return 'PROD';

    return 'LOCAL'; // Default fallback
  }

  //Centralized logic to calculate group based on environment and `isForceOnlyGsUser` flag
  private static getResolvedGroup(groupType: GroupType): { name: string; groupId: string } {
    if (GeneralUtils.isLocalDevEnv() && this.isForceOnlyGsUser) {
      return { name: 'vme-admin33', groupId: 'vme-admin33' };
    }
    // if (GeneralUtils.isLocalDevEnv() && this.isForceOnlyGsUser) {
    //   return { name: 'vme-admin33', groupId: 'vme-admin33' };
    // }

    const env = this.getEnvType();
    return ENV_CONFIG[env][groupType];
  }

  public static getVmeGlobalAdminGroup(): { name: string; groupId: string } {
    return this.getResolvedGroup('globalAdmin');
  }

  public static getVmeSupportGroup(): { name: string; groupId: string } {
    return this.getResolvedGroup('support');
  }

  public static getVmeSingleCompanyAdminGroup(): { name: string; groupId: string } {
    return this.getResolvedGroup('singleCompanyAdmin');
  }

  public static getVmePortalUserGroup(): { name: string; groupId: string } {
    return this.getResolvedGroup('portalUser');
  }

  // public static getVmeGlobalAdminGroup() {
  //   const env = this.getEnvType();

  //   let groupId = GeneralUtils.isLocalDevEnv() ? 'b9d13f54-7fe5-452c-8b1d-24db1e8c1875' : '80eee2f3-d108-4cf3-8505-d93d9a698fef' ;
  //   let name = GeneralUtils.isLocalDevEnv() ? 'vme-admin' : 'aad-app-admpnl-vmeadmin-prod' ;

  //   if (GeneralUtils.isLocalDevEnv() && this.isForceOnlyGsUser) {
  //     name = 'vme-admin33'; // can put ANY value except `vme-admin`
  //     groupId = 'vme-admin33';
  //   }

  //   return {name, groupId};
  // }
  // public static getVmeSupportGroup() {
  //   let groupId = GeneralUtils.isLocalDevEnv() ? 'b9d13f54-7fe5-452c-8b1d-24db1e8c1875' : '496adf28-cb09-4ad9-8f2b-35e4a3428281' ;
  //   let name = GeneralUtils.isLocalDevEnv() ? 'vme-admin' : 'aad-app-admpnl-vmesupport-prod' ;

  //   if (GeneralUtils.isLocalDevEnv() && this.isForceOnlyGsUser) {
  //     name = 'vme-admin33'; // can put ANY value except `vme-admin`
  //     groupId = 'vme-admin33';
  //   }

  //   return {name, groupId};
  // }
  // public static getVmeSingleCompanyAdminGroup() {
  //   const groupId = GeneralUtils.isLocalDevEnv() ? 'b9d13f54-7fe5-452c-8b1d-24db1e8c1875' : '3193d9d0-36c4-4e31-ae6e-c011405301e9' ;
  //   const name = GeneralUtils.isLocalDevEnv() ? 'vme-admin' : 'aad-app-admpnl-gsadmin-prod' ;

  //   return {name, groupId};
  // }

  public static isUrlInclude(value: string): boolean {
    let result = window.location.host.toLowerCase().includes(value);
    return result;
  }
}
